import { ApiBase } from '@/api/api'
import {
  makeDeleteRequest,
  makePatchRequest,
  makePostRequest,
} from '@/api/fetchCalls'
import type { AddPacketProps, Packet, PatialPacket } from '@/types/packet'

export const addPacket = async (packet: AddPacketProps): Promise<Packet> => {
  return await makePostRequest(`${ApiBase}/packets`, {
    body: JSON.stringify(packet),
  })
}

export const updatePacket = async (
  id: string,
  data: PatialPacket
): Promise<Packet> => {
  return await makePatchRequest(`${ApiBase}/packets/${id}`, {
    body: JSON.stringify(data),
  })
}

export const deletePacket = async (id: string): Promise<void> => {
  return await makeDeleteRequest(`${ApiBase}/packets/${id}`)
}
